import { Link } from 'components/Link';

import styles from './SoftballScores.module.scss';

export const SoftballScores = () => {
  return (
    <div className={styles.block}>
      <header>
        <h2>Latest Softball Scores</h2>
        <Link href="https://www.warrennolan.com/?utm_source=on3&utm_medium=logo&utm_campaign=softball_scores">
          <img
            alt="Warren Nolan"
            src="https://www.warrennolan.com/images/warren_nolan_blue-103x54.png"
            width={50}
          />
        </Link>
      </header>
      <section>
        <p>Show the top games of the day here.</p>
      </section>
      <div>
        <Link className={styles.viewAll} href={`/softball/scores/`}>
          View All Scores
        </Link>
      </div>
    </div>
  );
};
